import React from 'react';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';

interface AccessibilityStatementProps {
  onNavigate: (screen: string) => void;
}

const AccessibilityStatement: React.FC<AccessibilityStatementProps> = ({ onNavigate }) => {
  return (
    <div className="container">
      <SharedHeaderHomeowner onNavigate={onNavigate} />
      <div className="content" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', fontSize: '36px', fontWeight: '700', color: '#1f2937' }}>
          Accessibility Statement
        </h1>
        
        <div style={{ 
          background: '#ffffff', 
          padding: '40px', 
          borderRadius: '12px', 
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          lineHeight: '1.6',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            This statement was last updated on 24APR2025.
          </p>
          
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            At CoreBids, our goal is to ensure everyone — regardless of ability — can access the information, tools, and services we provide on CoreBids.com. We are committed to creating an inclusive and barrier-free experience for all users.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            Accessibility adjustments on this site
          </h2>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We have adapted this site in accordance with WCAG 2.1 guidelines and have made the site accessible to the level of AA. This site's contents have been adapted to work with assistive technologies, such as screen readers and keyboard navigation. As part of this effort, we have:
          </p>
          
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Used the Accessibility Wizard to find and fix potential accessibility issues</li>
            <li style={{ marginBottom: '8px' }}>Set the language of the site</li>
            <li style={{ marginBottom: '8px' }}>Set the content order of the site's pages</li>
            <li style={{ marginBottom: '8px' }}>Defined clear heading structures on all pages</li>
            <li style={{ marginBottom: '8px' }}>Added alternative text to images</li>
            <li style={{ marginBottom: '8px' }}>Implemented color combinations that meet the required color contrast</li>
            <li style={{ marginBottom: '8px' }}>Reduced the use of motion on the site</li>
            <li style={{ marginBottom: '8px' }}>Ensured all videos, audio, and files on the site are accessible</li>
          </ul>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            Technology compatibility
          </h2>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We aim to make our website compatible with:
          </p>
          
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>The latest versions of major browsers, including Chrome, Edge, Firefox, and Safari</li>
            <li style={{ marginBottom: '8px' }}>Popular screen readers such as JAWS, NVDA, and VoiceOver</li>
            <li style={{ marginBottom: '8px' }}>Both desktop and mobile devices</li>
          </ul>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            Known limitations
          </h2>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            While we strive for full compliance, some older archived content or third-party integrations may not yet meet all accessibility standards. We are actively working to address these issues and aim to have them resolved by our next scheduled review.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            Continuous improvements
          </h2>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We are dedicated to improving the accessibility of our website. Accessibility testing and improvements are ongoing, with our next scheduled review planned for October 2025.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            Feedback and response time
          </h2>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            If you encounter any barriers or have suggestions to enhance your experience, please contact us. We aim to respond to all accessibility-related inquiries within 5 business days.
          </p>
          
          <div style={{ 
            background: '#f3f4f6', 
            padding: '20px', 
            borderRadius: '8px', 
            marginTop: '16px',
            border: '1px solid #e5e7eb'
          }}>
            <p style={{ margin: '0', fontSize: '16px' }}>
              <strong>Email:</strong> info@corebids.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityStatement; 